import { pick } from 'lodash-es'
import { getSummaryValue, makeExpEstRow, makeExpEstHeaders, getTitle, makeModelTable } from '../utils'
import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'

const modelSummaryMapper = (item, meta) => {
  const selectedValue = getSummaryValue(item?.selectedValue ?? item?.predicted, getTitle(meta))

  return {
    values: [selectedValue],
    tables: [
      {
        headers: makeExpEstHeaders(),
        rows: [makeExpEstRow(item?.experimental, item?.predicted, getTitle(meta))],
      },
    ],
  }
}

const modelDescriptorsMapper = (item) => ({
  tables: item?.predicted?.model?.models?.map((model) => makeModelTable(model)),
})

const logKoc = (items) => {
  const item = items?.find((item) => item?.property === 'logKoc')
  const meta = findEpiSuiteGroupById('logKoc')

  return {
    title: getTitle(meta),
    description: meta?.description,
    helpPage: meta?.helpPage,
    summary: modelSummaryMapper(item, meta),
    modelDescriptors: modelDescriptorsMapper(item, meta),
    modelOutput: item?.predicted?.model?.output,
  }
}

export { logKoc }
